import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/FileTxtColor.tsx
const FileTxtColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "m15.897 2 5.6 5.687v12.25c0 1.692-1.333 3.063-2.978 3.063H7.029c-1.645 0-2.978-1.371-2.978-3.062V5.062C4.05 3.371 5.384 2 7.029 2h8.868Z",
			fill: "url(#paint0_linear_869_1203)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "m18.733 4.844 2.766 2.843v4.375L16.392 7.25l2.34-2.406Z",
			fill: "url(#paint1_linear_869_1203)",
			fillOpacity: .3
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.499 7.688h-4.256c-.705 0-1.346-.588-1.346-1.313V2L21.5 7.688Z",
			fill: "#26ADEE"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M1.5 12.588c0-1.208.953-2.188 2.128-2.188h11.489c1.175 0 2.128.98 2.128 2.188v5.687c0 1.209-.953 2.188-2.128 2.188H3.627c-1.174 0-2.127-.98-2.127-2.188v-5.687Z",
			fill: "url(#paint2_linear_869_1203)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M15.117 10.4c1.175 0 2.128.98 2.128 2.188 0-1.087-.953-1.969-2.128-1.969H3.627c-1.174 0-2.127.882-2.127 1.969 0-1.208.953-2.188 2.128-2.188h11.489Z",
			fill: "#fff",
			fillOpacity: .7
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.654 13.867v-.848h3.943v.848H14.12v4.102h-.99v-4.102h-1.477ZM8.37 13.02l.983 1.702h.034l.99-1.702h1.13l-1.469 2.474 1.503 2.475h-1.157l-.997-1.702h-.034l-.997 1.702h-1.15l1.509-2.475-1.483-2.474H8.37ZM3.156 13.867v-.848H7.1v.848H5.623v4.102h-.99v-4.102H3.155Z",
			fill: "#EFF9FF"
		}),
		/* @__PURE__ */ jsxs("defs", { children: [
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint0_linear_869_1203",
				x1: 12.774,
				y1: 2,
				x2: 12.774,
				y2: 23,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#A6E9FF" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#5FCAFF"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint1_linear_869_1203",
				x1: 18.945,
				y1: 4.844,
				x2: 18.945,
				y2: 12.063,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#1384BA" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#92DDFE"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint2_linear_869_1203",
				x1: 9.372,
				y1: 10.4,
				x2: 9.372,
				y2: 20.463,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#4DABED" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#3590D3"
				})]
			})
		] })
	]
}));
//#endregion
export { FileTxtColorIcon };
